import React from 'react';
import { 
  CodingImg,
  ConsultingImg,
  DesignImg,
  SeoImg,
  WritingImg,
  ProfreadingImg,
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Margin, P } from '@helpers';

export const Roles = ({t}) => {
  return (
    <PageWrapper darkMode={false}>
        <Container paddingTop='99px' marginLeft='102px' paddingBottom='32px' marginRight='69px'>
          <Text width='657px' paddingBefforeText="45px">
            <h1>{t("Roles and responsibilities")}</h1>
            <p>
              {t("Roles and responsibilities in content production depend not so much on the position of the employee, but on the type of work they perform in the chain to produce a particular piece of content. This list of positions is for reference purposes only.")}
            </p>
          </Text>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="71px">
              <P weight='600' size='15px' height='30px'>{t("Content writing")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("Typically, the creation of the initial draft with content is handled by a content manager or copywriter. However, any competent Soft-FX employee who is able to make a coherent statement on a particular topic can be in this role.")}
              </P>
            </Margin>
            <Margin marginTop='47px'>
              <WritingImg/>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="71px">
              <P weight='600' size='15px' height='30px'>{t("Tech consulting")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("Any employee who is educated in the technical aspects of the content piece topic is capable of taking on this responsibility.")}
              </P>
            </Margin>
            <Margin marginTop='20px'>
              <CodingImg/>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="71px">
              <P weight='600' size='15px' height='30px'>{t("Legal consulting")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("A piece of content may need legal advice on occasion. It can be requested from specialists in the legal department.")}
              </P>
            </Margin>
            <Margin marginTop='23px'>
              <ConsultingImg/>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="71px">
              <P weight='600' size='15px' height='30px'>{t("SEO")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("Often search engine optimization determines how our content performs online. If required, the technical assignment for the content is prepared by SEO specialists.")}
              </P>
            </Margin>
            <Margin marginTop='39px'>
              <SeoImg/>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="71px">
              <P weight='600' size='15px' height='30px'>{t("Proofreading")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("Proofreading is performed by the company's employees fluent in the language of the particular content piece.")}
              </P>
            </Margin>
            <Margin marginTop='39px'>
              <ProfreadingImg/>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='98px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="71px">
              <P weight='600' size='15px' height='30px'>{t("Visual design")}</P>
              <P weight='400' size='15px' height='30px' marginTop='10px'>
                {t("Almost all of the content we produce needs visual design.  This responsibility rests entirely with the visual department. However, prior discussion of any ideas with designers is always encouraged.")}
              </P>
            </Margin>
            <Margin marginTop='39px'>
              <DesignImg/>
            </Margin>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};